import { Routes } from '@angular/router';
import { LoginComponent } from './index';

export const LoginRoutes: Routes = [
    {
      path: '', component: LoginComponent
    }
];



// WEBPACK FOOTER //
// ./src/app/login/login.routes.ts